import {styled} from '@mui/material';
import {IconIllustration} from 'presentation/components';

const DataContainer = styled('div')`
	display: flex;
	flex-direction: column;
	padding: 18px 16px;
	border: ${({theme}) => `1px solid ${theme.palette.divider}`};
	border-radius: 16px;
	gap: 24px;
`;

const CustomIconIllustration = styled(IconIllustration)`
	width: 40px !important;
	height: 40px !important;
	justify-content: center;
	align-items: center;
	display: flex;
`;

export {DataContainer, CustomIconIllustration};
